// Settings (spec/25 §14, §16): the venue's Clavian Boot settings — how the boot server answers PCs, where a PC keeps its
// changes, the caches and what happens after a new image version is published. They are the registry's own, drawn here by
// the same screen as the venue's Settings (its "Clavian Boot" group), so a change is saved, versioned and audited exactly
// as on that screen. Editing needs `boot:manage`; the server checks it on every save.

import type { MyVenue } from '../api/me';
import { useTranslation } from '@clavian/i18n/react';
import { useMemo, type ReactNode } from 'react';

import { Loading } from '../shell/layouts';
import { LoadFailure } from '../shell/LoadFailure';
import { RegistryGroup, useSettingsView } from '../settings/SettingsPage';
import type { SettingsScope } from '../settings/registry-source';

export function BootSettingsTab({ venue }: { readonly venue: MyVenue }): ReactNode {
  const { t } = useTranslation('console');
  const scope = useMemo<SettingsScope>(() => ({ kind: 'venue', organizationId: venue.organizationId, venueId: venue.id }), [venue.organizationId, venue.id]);
  const { query } = useSettingsView(scope);
  if (query.data === undefined) {
    return query.isError ? <LoadFailure error={query.error} message={t('boot.settings.unavailable')} onRetry={() => void query.refetch()} /> : <Loading />;
  }
  return (
    <div className="console-boot__stack">
      <p className="console-muted">{t('boot.settings.intro')}</p>
      <RegistryGroup scope={scope} group="clavianBoot" view={query.data} links={{}} reveal={undefined} />
    </div>
  );
}
